import type { Directive, DirectiveBinding } from 'vue';

interface MiDirectivaIfBinding extends DirectiveBinding {
  value: boolean;
}

const checkPermision: Directive = {
  mounted(el: HTMLElement, binding: MiDirectivaIfBinding) {
    applyPermissionStyle(el, binding.value);
  },

  updated(el: HTMLElement, binding: MiDirectivaIfBinding) {
    applyPermissionStyle(el, binding.value);
  },

  beforeUnmount(el: HTMLElement) {
    // Cleanup para evitar memory leaks
    el.removeEventListener('click', preventClickHandler);
    el.removeEventListener('keydown', preventKeyHandler);
  }
};

// Handler para prevenir eventos en elementos sin permisos
const preventClickHandler = (event: Event) => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
};

const preventKeyHandler = (event: KeyboardEvent) => {
  if (['Enter', 'Space', ' '].includes(event.key)) {
    event.preventDefault();
    event.stopPropagation();
  }
};

// Aplicar estilos y comportamientos basados en permisos
function applyPermissionStyle(el: HTMLElement, hasPermission: boolean) {
  if (!hasPermission) {
    // Ocultar visualmente pero mantener en el DOM
    el.style.display = 'none';
    el.style.visibility = 'hidden';
    el.style.position = 'absolute';
    el.style.height = '0';
    el.style.width = '0';
    el.style.overflow = 'hidden';
    
    // Prevenir interacción
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.style.pointerEvents = 'none';
    
    // Agregar event listeners para prevenir cualquier interacción
    el.addEventListener('click', preventClickHandler, true);
    el.addEventListener('keydown', preventKeyHandler, true);
    
    // Agregar clase para estilos adicionales
    el.classList.add('permission-denied');
  } else {
    // Restaurar estilos y funcionalidad
    el.style.display = '';
    el.style.visibility = '';
    el.style.position = '';
    el.style.height = '';
    el.style.width = '';
    el.style.overflow = '';
    
    // Restaurar accesibilidad
    el.removeAttribute('aria-hidden');
    el.removeAttribute('tabindex');
    el.style.pointerEvents = '';
    
    // Remover event listeners
    el.removeEventListener('click', preventClickHandler, true);
    el.removeEventListener('keydown', preventKeyHandler, true);
    
    // Remover clase
    el.classList.remove('permission-denied');
  }
}

export default checkPermision;